<template>
  <hgroup>
    <h2 v-if="subTitle" class="secondary--text text-uppercase subheading font-weight-bold">{{ subTitle }}</h2>
    <h1 class="display-2 font-weight-black mb-1">{{ title }}</h1>
  </hgroup>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String
    }
  }
}
</script>
